import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import * as Highcharts from 'highcharts';
import Stock from 'highcharts/modules/stock';
import * as HighchartsPatternFill from 'highcharts/modules/pattern-fill';



Stock(Highcharts);

import { HttpClient } from '@angular/common/http';
import { BarserviceService } from '../../barservice.service'
import { Observable, Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';

@Component({
  selector: 'app-barchart01',
  templateUrl: './barchart01.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Barchart01Component implements OnInit {
  chart: any;
  event: any;
  datalabel: any = false;
  barChartData: any;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
  @Input() data: any;
  defaultCategories1: any;
  max: any;
  min: any;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = "#ff0000";
  maxDataPoints: any = 11;
  maxSeries: any;
  categoryImages: any;
  customizationList: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  private subscriptions: Subscription = new Subscription();

  constructor(private http: HttpClient, private barService: BarserviceService, private _configService: SnapshotService) { }
  @Input() id: any;
  @Input() height: any;
  @Input() popUp: any = false;
  significanceValue: any = "None";
  @ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;
  ngOnInit(): void {
    this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
   
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe(value => {
        this.DefaultConfidenceLevel = value;
        this.updateSig();
      }));
    this.subscriptions.add(
      this._configService.significanceValue.subscribe(value => {
        this.significanceValue = value;
        this.updateSig();
      }));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateSig();
  }

  chartMainData: any = [];

  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        //this.data = data[0];
        this.barChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
        this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.preparemainChartData(this.data);
        //this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
        this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

        let docEle = document.getElementById('chart-container' + this.id)
        if (docEle != null) {
          docEle.innerHTML = '';
        }

        this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
      }));
  }

  preparemainChartData(data: any) {
    let i = 0;
    this.chartMainData = [];
    data.forEach((lev1: any) => {
      lev1.metricSelected.metrics.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev1.submetricName,
            "Category Name": lev2.metricName,
            "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "XValue": ++i,
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,  
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    })
    // this.chartMainData=this.chartMainData.slice(0,1);
  }

  getData(chartData: any, lowSample1: any) {
    let seriesData: any[] = [];
    let value = 0;
    let i = 0;
    let maxValue = 0;
    let minValue = 0;
    let j = -1;
    let finalValue = 0;


    chartData[0].data = this.chartMainData;

    //get the first series name
    const firstItem = chartData[0].data[0]['Series Name'];

    //get the category images
    this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
    this.categoryImages = [''].concat(this.categoryImages);
    //extract all data matching the series name
    const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);


    //calculate the min and max value for the y-axis
    maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
    minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
    this.max = maxValue + Math.ceil(maxValue * 0.10);
    this.min = minValue + Math.ceil(minValue * 0.10);

    //loop throught he filtered data
    this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

      //extract rounded value,if null plot as 0
      value: item['Value'] == null ? 0 : this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff),
      //if lowsample is selected,if rounded value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
      numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
      //name for each datapoint
      name: item['Category Name'],

      //apply pattern/gradient bar color or default color based on selection
      color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],

      visible: true,
      zIndex: 2,
      type: 'column',
      dataLabels: {

        borderWidth: 0,

      },
      data: [{
        name: item['Category Name'],
        seriesName: item['Series Name'],
        ispercent: item["isPercentage"],
        y: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0)),
        //x value is used just to assign different colors for each bar
        x: parseInt(item['XValue']),
        indexValue: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0)),
        actualIndexValue: item['ActualIndexValue']

      }],

      //extract changeVs value
      changeValueSeries: indiaData.map((item: { [x: string]: string }) => (item["Change value vs PY"])),
      //extract significance value
      significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
      //extract significance2 value
      significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
      //extract sample size value
      sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
      //extract rounded value
      roundedValue: indiaData.map((item: { [x: string]: string }) => item["Rounded Value"]),
      //include tooltip to reflect the datalabel property selected
      tooltip: [],
      isPercentage: item["isPercentage"],
      Sig_LowerLimt: this.Sig_LowerLimt,
      Sig_UpperLimt: this.Sig_UpperLimt,
      Significance_Value: item["Significance_Value"],



    }));


    if (this.seriesData1.filter((x: any) => x.value == 0).length > 0)
      this.min = 0


    //extract category names
    this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
    this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

    //include additional series for marker
    indiaData.forEach((item: { [x: string]: string }, index: number) => {
      let markerStyle = this.properties.markerStyle;
      let offsetMultiplier = 0.03;
      // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
      if (parseFloat(item['Rounded Value']) < 0 && markerStyle === 'triangle') {
        markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
      }
      if (parseFloat(item['Rounded Value']) < 50 && parseFloat(item['Rounded Value']) > 0) {
        offsetMultiplier = 0.1; // Further increase offset if value is less than 50
      }
      if (parseFloat(item['Rounded Value']) <= 80 && parseFloat(item['Rounded Value']) >= 50 && parseFloat(item['Rounded Value']) > 0) {
        offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
      }

      this.seriesData1.push({
        name: item['Category Name'],
        type: 'scatter',
        zIndex: 1,
        marker: {
          symbol: markerStyle,
          fillColor: 'red',
          lineColor: 'red',
          lineWidth: 2,
        },
        enableMouseTracking: false,
        showInLegend: false,
        visible: this.properties.marker === 'enable',
        data: [{
          name: item['Category Name'],
          y: !lowSample1 ? (item['Rounded Value'] == null || parseFloat(item['Rounded Value']) === 0) ? null :
            parseFloat(item['Rounded Value']) > 0 ? parseFloat(item['Rounded Value']) + (offsetMultiplier * parseFloat(item['Rounded Value'])) :
              parseFloat(item['Rounded Value']) + (0.04 * parseFloat(item['Rounded Value'])) :
            (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Rounded Value'] != null && parseFloat(item['Rounded Value']) !== 0) ?
              parseFloat(item['Rounded Value']) > 0 ? parseFloat(item['Rounded Value']) + (0.03 * parseFloat(item['Rounded Value'])) :
                parseFloat(item['Rounded Value']) + (0.05 * parseFloat(item['Rounded Value'])) : null,
          x: index + 1,
          z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ?
            0 :
            (item['Rounded Value'] != null ?
              parseFloat(item['Rounded Value']) :
              0),
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: item['Significance_Value']
        }],
      });
    });



  }


  customization(): Observable<any[]> {
    return this.barService.VerticalBarcustomizationList();
  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.barService.applycustomization(event, item, this.properties)
    this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
    this.getBarChart('chart-container', this.seriesData1, this.properties);
  }
  getBarChart(containerId: string, seriesData: any[], properties: any) {

    localStorage.setItem("properties", JSON.stringify(this.properties));
    let serviceBar = this.barService;
    let i = 0;
    const updatedCategories1 = this.categoryImages;
    const defaultCategories = this.categories;

    const screenHeight = window.innerHeight; // Get the screen width
    let xAxisyLabelPosition;

    let height = '48%';
    if (screenHeight <= 610) { //for 150% -> 593
      xAxisyLabelPosition = this.popUp ? 50 : 30;
    } else if (screenHeight <= 800) { //for 125% -> 738

      xAxisyLabelPosition = this.popUp ? 40 : 5;
    } else if (screenHeight <= 1200) { //for 100%
      xAxisyLabelPosition = this.popUp ? 95 : 15;
      height = '40%';
    }

    const configService = this._configService;

    const options: Highcharts.Options = {
      chart: {
        type: 'column',
        reflow: true,
        height: height,
        //marginBottom: defaultCategories.length > (this.maxDataPoints + 1) ? 40 : 0,

        //apply background color and text color based on light or dark theme
        backgroundColor: this.properties.darkTheme
          ? this.barService.darkThemeBackgroundColor
          : this.barService.defaultThemeBackgroundColor,
        style: {
          fontFamily: this.barService.textfont,
          color: this.properties.darkTheme
            ? this.barService.darkThemeTextColor
            : this.barService.defaultThemeTextColor,
          height: this.height != '100%' ? 200 : this.height,
          fontSize: '0.7rem',
        },
        events: {
          //to hide the marker along with the bar,when legend is click for each bar
          redraw: function (this: any) {
            // Adjust scatter series position after redrawing the chart
            var chart = this,
              series = chart.series;

            series.forEach(function (ser: any) {
              if (ser.type === 'column' && ser.type == 'scatter') {
                ser[1].forEach(function (scatter: any) {
                  scatter.setVisible(ser.visible, false);
                });
              }
            });
          },
          load: function () {
            const chart = this;
            // window.addEventListener('resize', function () {
            //   chart.reflow();
            // });
            //#region wheel scroll
            const container = chart.container;
            const xAxis = chart.xAxis[0];

            function onWheel(e: any) {
              e = e || window.event;
              e.preventDefault();

              // Normalize wheel delta
              let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
              delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

              const extremes = xAxis.getExtremes();
              const step = 1; // how many categories to scroll at a time

              let newMin = extremes.min + delta * step;
              let newMax = extremes.max + delta * step;

              // Bound checks
              if (newMin < extremes.dataMin) {
                newMin = extremes.dataMin;
                newMax = newMin + (extremes.max - extremes.min);
              }
              if (newMax > extremes.dataMax) {
                newMax = extremes.dataMax;
                newMin = newMax - (extremes.max - extremes.min);
              }

              xAxis.setExtremes(newMin, newMax, true, false);
            }

            container.addEventListener('wheel', onWheel, {
              passive: false,
            });
            //#endregion
          },
        },
      },
      title: {
        //add title styles :position and color options
        // text: this.data.title,
        text: '',
        align: this.properties.chartTitlePosition,
        style: {
          color: this.properties.darkTheme
            ? this.barService.darkThemeTextColor
            : this.barService.defaultThemeTextColor,
          marginleft: '4%',
          fontSize: '1em',
          fontFamily: this.barService.textfont,
        },
      },
      subtitle: {},
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      //legend position
      legend: this.barService.customizeLegend(
        this.chart,
        this.properties.showLegend,
        this.properties.legendPosition,
        this.properties
      ), // Semicolon added

      xAxis: {
        lineColor: '#A2A2A2', // Change to desired axis line color
        lineWidth: 1,
        categories: defaultCategories,
        //shows 10 bars in each slide
        min: 1,
        max: this.seriesData1.length / 2 <= 8 ? this.seriesData1.length / 2 : 8,
        //if number of bars are greater than 10,scrollbar is seen
        //scrollbar styles
        scrollbar: {
          enabled:
            defaultCategories.length > this.maxDataPoints + 1 ? true : false,
          height: 5, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#7f7f7f',//#8600CD,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBackgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBorderWidth: 0,
          buttonArrowColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
          margin: 20,
        },
        showEmpty: false,
        labels: {
          //x-axis labels styles
          useHTML: true,
          y: xAxisyLabelPosition,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
          },
          formatter: function (
            this: Highcharts.AxisLabelsFormatterContextObject
          ) {
            //x-axis images are added
            const xaxislabelvalue =
              String(this.value).length > 12
                ? String(this.value).substring(0, 10) + '...'
                : String(this.value);
            if (properties.axisImage) {
              let index = defaultCategories.indexOf(String(this.value));
              let i = 0;
              const category1 =
                serviceBar.baseImgPath + updatedCategories1[index] + '.png';
              if (category1) {
                return (
                  '<span style="display: inline-block; width: 2em; height: 2em; background: url(' +
                  category1 +
                  ') no-repeat center center; background-size: cover;"></span>'
                );
              } else {
                return '<span>No Image</span>';
              }
            } else {
              return `<div style="padding: 0% 4%;" title="${String(
                this.value
              )}">${xaxislabelvalue}</div>`;
            }
          },

          //axis label orientation
          rotation: this.barService.axisLabelOrientation(
            this.properties.axisLabelOrientation
          ), // Rotate labels by -90 degrees (or any other desired angle)
        },
      },
      yAxis: {
        //min and max for y-axis
        max: null,
        min: 0,
        plotLines: [
          {
            value: 0,
            width: 1,
          },
        ],
        tickInterval: 20,
        //gridlines visibility
        gridLineWidth: this.properties.gridlines ? 1 : 0,

        //y-axis labels styles
        labels: {
          enabled: false,
          format:
            this.properties.datalabelFormat == 'percentage'
              ? '{value}%'
              : '{value}',
          style: {
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
            fontFamily: this.barService.textfont,
          },
        },
        title: {
          text: '', // Set an empty string to hide the yAxis title
        },
      },
      //tooltip styles
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        // shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',

        formatter: function (this: any) {
          //disable tootltip for marker
          if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = serviceBar.color1[this.point.x - 1]; // Get the series color
          const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel
            ? this.series.userOptions.tooltip[this.point.x - 1]
            : this.y;

          if (isDefaultTooltip == 'style1') {
            const commonContent =
              `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};width:fit-content; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
              //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
              //`<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
              `${this.point.name}: ` +
              `${text}`;

            return commonContent + '</div>';
          } else {
            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
              `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
              ` ${this.series.name}` +
              `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;

            return content + '</div>';
          }
        },
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          animation: false,
          allowPointSelect: false,
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              enabled: false,
            },
            select: {
              enabled: false,
            },
          },
          //animation is set to off for datalabeposition* as it is applicable only for aspose side
          // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
          events: {
            //when a legend is clicked fro the bar,bar must disappear
            legendItemClick: function (this: any) {
              var series = this.chart.series,
                selectedSeriesName = this.name;

              // Loop through all series
              for (var i = 0; i < series.length; i++) {
                // Check if the series name matches the clicked legend's series name
                if (series[i].name === selectedSeriesName) {
                  // Toggle visibility of both bar and scatter series
                  series[i].setVisible(!series[i].visible, false);
                  if (series[i].type == 'scatter') {
                    series[i].scatterSeries.setVisible(
                      !series[i].visible,
                      false
                    );
                  }
                }
              }

              // Redraw the chart
              this.chart.redraw();

              // Prevent default legend item click action
              return false;
            },
          },
        },
        column: {
          //plotting styles

          //distance between bars
          pointPadding: 2,
          groupPadding: 3,
          grouping: false,
          stacking: undefined,
          //shadow styles
          shadow: this.properties.shadow
            ? {
                color: this.barService.shadowColor,
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
            : false,
          //bar size
          pointWidth: 25,
          //datalabel styles
          dataLabels: {
            style: {
              backgroundColor: this.barService.transparentBackground,
              //datalabel border
              textOutline: 'none',
              //datalabel color
              color: this.properties.darkTheme
                ? this.properties.dataLabelColor === 'default'
                  ? 'white'
                  : this.properties.dataLabelColor ||
                    this.barService.darkThemeTextColor
                : this.properties.dataLabelColor === 'default'
                ? 'black'
                : this.properties.dataLabelColor ||
                  this.barService.defaultThemeTextColor,
              //datalabel font size
              fontSize: '0.8em',
              fontWeight: 'normal',
              fontFamily: this.barService.textfont,
            },

            overflow: 'allow',
            crop: false,
            //enable the datalabel based on selection
            enabled: this.properties.showDataLabel,
            //datalabel is shown inside the bar
            inside: false,

            //datalabel alignment
            align: this.properties.dataLabelPosition,
            //datalabel overlap is set to true by default
            allowOverlap: true,
            //datalabel position
            verticalAlign: this.properties.dataLabelPosition,
            y: this.properties.dataLabel_y_positionVertical,
            x:
              properties.datalabelStyle == 'index'
                ? this.properties.dataLabel_x_position - 10
                : this.properties.dataLabel_x_position,

            formatter: function (this: any) {
              if (properties.datalabelStyle == 'index') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y + (this.series.data[0].ispercent ? '%' : '')
                    : serviceBar.nullValueText;

                text = configService.CheckLSorIScondition(
                  configService.userRole,
                  text,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );

                this.series.userOptions.tooltip[this.point.x - 1] = text;

                // let text2 = this.series.userOptions.roundedValue[this.point.x - 1] === 0
                //   ? serviceBar.nullValueText
                //   : this.series.userOptions.roundedValue[this.point.x - 1] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.point.indexValue : serviceBar.nullValueText;

                let text2 =
                  this.point.actualIndexValue == null
                    ? serviceBar.nullValueText
                    : this.series.userOptions.roundedValue[this.point.x - 1] ==
                      -1
                    ? -1
                    : this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null
                    ? this.point.indexValue
                    : serviceBar.nullValueText;

                if (text2 == '-1' || text2 == -1) {
                  text2 = 'NA';
                }
                text2 = configService.CheckLSorIScondition(
                  configService.userRole,
                  text2,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );

                let color = configService.CheckIndexColoring(text2);

                this.series.userOptions.tooltip[this.point.x - 1] =
                  text + '(' + text2 + ')';
                return (
                  '<span style="font-size:0.5rem;">' +
                  text +
                  '</span>' +
                  '<span style="color:' +
                  color +
                  ';font-size:0.45rem;">' +
                  ' ' +
                  '(' +
                  text2 +
                  ')</span>'
                );
              }

              if (properties.datalabelStyle == 'sigChange') {
                //extract each changeVs value
                let changeText = this.series.userOptions.isPercentage
                  ? this.series.userOptions.changeValueSeries[
                      this.point.x - 1
                    ] * 100
                  : this.series.userOptions.changeValueSeries[this.point.x - 1];
                //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                let textCheck = configService.CheckLSorIScondition(
                  configService.userRole,
                  this.y,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? textCheck +
                      (this.series.userOptions.isPercentage &&
                      textCheck != 'I/S'
                        ? '%'
                        : '')
                    : serviceBar.nullValueText;
                text = textCheck;
                //extarct each signififcance value
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                //set the significance arrow according to its value
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                //assign color to the arrow
                let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                //include + if changeValue is positive
                // if (parseFloat(changeText) > 0) {
                //   changeText = "+" + changeText;
                // }
                let sigClass =
                  this.series.userOptions.Significance_Value <
                  this.series.userOptions.Sig_LowerLimt
                    ? 'red'
                    : this.series.userOptions.Significance_Value >
                      this.series.userOptions.Sig_UpperLimt
                    ? 'green'
                    : 'black';
                //merge text+changeText+significance
                if (
                  this.series.userOptions.changeValueSeries[this.point.x - 1] ==
                    null ||
                  this.series.userOptions.changeValueSeries[this.point.x - 1] ==
                    'NA'
                ) {
                  let finalText =
                    '<span>' +
                    '<span>' +
                    text +
                    '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && textCheck != 'I/S'
                      ? '<span>&nbsp' +
                        '<span style="color:' +
                        sigClass +
                        '; font-size: 70%;  ">(NA)</span>&nbsp;' +
                        '</span>'
                      : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  //return the finalText
                  return finalText;
                } else {
                  let finalText =
                    '<span>' +
                    '<span>' +
                    text +
                    '</span>' +
                    (this.series.userOptions.Significance_Value == 0
                      ? '<span style="color:' +
                        sigClass +
                        '; font-size: 70%;  ">(' +
                        (this.series.userOptions.Significance_Value +
                          (this.series.userOptions.isPercentage ? '%' : '')) +
                        ')</span>&nbsp;' +
                        '</span>'
                      : this.series.userOptions.roundedValue[
                          this.point.x - 1
                        ] != null &&
                        changeText &&
                        textCheck != 'I/S'
                      ? '<span>&nbsp' +
                        '<span style="color:' +
                        sigClass +
                        '; font-size: 70%;  ">(' +
                        (parseFloat(Number(changeText).toFixed(1)) +
                          (this.series.userOptions.isPercentage ? '%' : '')) +
                        ')</span>&nbsp;' +
                        '</span>'
                      : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  //return the finalText
                  return finalText;
                }
              }

              //significance and changeVs option is selected from datalabel property
              if (properties.datalabelStyle == 'significance + changeVs') {
                //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                //extract each changeVs value
                let changeText =
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                //extarct each signififcance value
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                //set the significance arrow according to its value
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                //assign color to the arrow
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                //include + if changeValue is positive
                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                //merge text+changeText+significance
                let finalText =
                  '<span>' +
                  '<span>' +
                  text +
                  '</span>' +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null && changeText
                    ? '<span>&nbsp' +
                      '<span style="font-size: ' +
                      serviceBar.changeValueFontSize +
                      ';color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      '; ">(' +
                      changeText +
                      ')</span>&nbsp;' +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                //assign the finalText to tooltip
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                //return the finalText
                return finalText;
              }
              if (properties.datalabelStyle == 'change') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let finalText =
                  '<span>' +
                  text +
                  '  ' +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null && changeText
                    ? '<span>&nbsp' +
                      '<span style="font-size: ' +
                      serviceBar.changeValueFontSize +
                      ';color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      '; ">(' +
                      changeText +
                      ')</span>&nbsp;' +
                      '</span>'
                    : '');
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }

              if (properties.datalabelStyle == 'ls') {
                let text =
                  parseFloat(
                    this.series.userOptions.sampleSize[this.point.x - 1]
                  ) > serviceBar.sampleSizeConstant
                    ? this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText
                    : serviceBar.lowSampleText;
                let finalText =
                  '<b>' + text + '</b> ' + '<span style="opacity: 0.5"></span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }
              if (properties.datalabelStyle == 'significance') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                let finalText =
                  '<span >' +
                  text +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                  null
                    ? '&nbsp<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }
              if (properties.datalabelStyle == 'default') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y + (this.series.data[0].ispercent ? '%' : '')
                    : serviceBar.nullValueText;

                text = configService.CheckLSorIScondition(
                  configService.userRole,
                  text,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );

                this.series.userOptions.tooltip[this.point.x - 1] = text;

                return '<span >' + text + '</span>';
              }
              if (properties.datalabelStyle == 'datalabel') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return '<span >' + text + '</span>';
              }

              if (properties.datalabelStyle == 'significance2') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                let sig1 =
                  this.series.userOptions.significance2[this.point.x - 1];
                let sColor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let changeColor =
                  sig1 < 0
                    ? serviceBar.lowSignificance
                    : sig1 > 0
                    ? serviceBar.highSignificance
                    : properties.darkTheme
                    ? serviceBar.darkThemeTextColor
                    : serviceBar.defaultThemeTextColor;

                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let finalText =
                  '<span>' +
                  text +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null && changeText
                    ? '&nbsp<span style="color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      ' "> ' +
                      '<span style="font-size:' +
                      serviceBar.changeValueFontSize +
                      '; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span>&nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }

              return !Number.isNaN(
                this.series.userOptions.roundedValue[this.point.x - 1]
              )
                ? this.y
                : 'NA';
            },
          },
        },
      },
      series: seriesData,
    };
    const containerEl = document.getElementById('chart-container' + this.id);
    if (!containerEl) { return; }
    Highcharts.chart(containerEl, options);

  }


  index = -1;

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    if (this.chart) { this.chart.destroy(); this.chart = null; }
     this.subscriptions.unsubscribe();
  }


}





